import { useEffect, type ReactNode } from "react";
import { cn } from "@/utils/cn";
import { CloseCircle } from "iconsax-react";

interface ModalWrapperProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  className?: string;
}

export const ModalWrapper = ({
  isOpen,
  onClose,
  title,
  children,
  className,
}: ModalWrapperProps) => {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 h-screen flex items-center justify-center bg-black/60 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className={cn(
          "flex flex-col relative w-full p-5 bg-dark-10 rounded-[5px] border border-dark-20 shadow-lg transition-all",
          className
        )}
        onClick={(e) => e.stopPropagation()}
      >
        {title && (
          <div className="flex justify-between items-center mb-5">
            <h2 className="text-base font-medium text-dark-text">{title}</h2>

            <button onClick={onClose} className="cursor-pointer">
              <CloseCircle color="#FEFEFE" size={24} />
            </button>
          </div>
        )}
        <div className="flex-1 flex flex-col overflow-hidden">{children}</div>
      </div>
    </div>
  );
};
